// @flow
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { grid } from '@finect/tabular-utils/grid';

export const PendingModerationBlock = styled.div`
  margin-bottom: 36px;
`;

export const MainContent = styled.div`
  width: 100%;
  max-width: ${grid(7)}px;
  margin: 0 auto;
  ${({ noMargin }) => (noMargin ? null : 'margin-bottom: 30px;')};
`;

export const SpinnerBlock = styled.div`
  margin-top: 12px;
  text-align: center;
`;

export const ButtonContainer = styled.div`
  margin-top: 12px;

  ${maxMediaQueries.phone`
    margin-top: 0;
    margin-bottom: 12px;
    width: 100%;
    display: flex;
    justify-content: center;
`};
`;
